import { render } from "./VueEx.vue?vue&type=template&id=babdd552"
import script from "./VueEx.vue?vue&type=script&lang=js"
export * from "./VueEx.vue?vue&type=script&lang=js"

import "./VueEx.vue?vue&type=style&index=0&id=babdd552&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__